class CustomQtyATC extends HTMLElement {
  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
  }
  connectedCallback() {
    this.addEventListener("click", this.handleClick);
    this.syncQtyFromCart();

    this.cartUpdateListener = this.handleCartUpdate.bind(this);
    document.addEventListener("cart:updated", this.cartUpdateListener);
  }
  disconnectedCallback() {
    this.removeEventListener("click", this.handleClick);
    document.removeEventListener("cart:updated", this.cartUpdateListener);
  }
  handleClick(e) {
    var atcBtn = e.target.closest(".atc_btn_JS"),
        plusBtn = e.target.closest(".qty_btn.plus"),
        minusBtn = e.target.closest(".qty_btn.minus"),
        container = this,
        qtyValEl = container.querySelector(".qty_value"),
        qty = parseInt(qtyValEl.getAttribute("qty_value")) || 0,
        inventory = parseInt(container.getAttribute("inventory_quantity")) || 0,
        variantid = parseInt(container.getAttribute("variantid"));

    if (atcBtn) {
      container.classList.remove("qty_hide");
      qty++;
    }
    if (plusBtn) {
      qty++;
    }
    if (minusBtn) {
      if (qty <= 1) {
        container.classList.add("qty_hide");
        qty = 0;
      } else {
        qty--;
      }
    }
    qtyValEl.textContent = qty;
    qtyValEl.setAttribute("qty_value", qty);
    
    var plus = container.querySelector(".qty_btn.plus");
    if (qty >= inventory) {
      plus.classList.add("disabled");
    } else {
      plus.classList.remove("disabled");
    }

    document.body.classList.add('stopCustomQtyATCWorking');

    if(container.closest('.cart_drawer_tabs_content')){
      addRemoveUpdateSelector(variantid,qty);
    }else{      
      addRemoveUpdate(variantid,qty);
    }

    document.dispatchEvent(new CustomEvent("cart:updated", {
      detail: {
        variantId: variantid,
        qty: qty
      }
    }));

    showCustomProductRecommendations(container,qty);
  }

  syncQtyFromCart() {
        var container = this,
            variantid = parseInt(container.getAttribute("variantid")),
            cartItems = JSON.parse(localStorage.getItem('cartItemLocalStorage') || '[]'),
            item = cartItems.find(i => i.id == variantid),
            qtyValEl = container.querySelector(".qty_value");

        if (item) {
          qtyValEl.textContent = item.quantity;
          qtyValEl.setAttribute("qty_value", item.quantity);
          container.classList.remove("qty_hide");
        }else {
          qtyValEl.textContent = 0;
          qtyValEl.setAttribute("qty_value", 0);
          container.classList.add("qty_hide");
        }
    }
    handleCartUpdate(e) {
        var container = this,
            variantid = parseInt(container.getAttribute("variantid")),
            qtyValEl = container.querySelector(".qty_value");

        if (variantid == e.detail.variantId) {
            var qty = e.detail.qty;

            qtyValEl.textContent = qty;
            qtyValEl.setAttribute("qty_value", qty);

            if (qty > 0) {
                container.classList.remove("qty_hide");
            } else {
                container.classList.add("qty_hide");
            }
        }
    }
}

if (!customElements.get("custom-qty-atc")) {
  customElements.define("custom-qty-atc", CustomQtyATC);
}

class CartDrawerOpener extends HTMLElement {
  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
  }
  connectedCallback() {
    this.addEventListener('click', this.handleClick);
  }
  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
  }
  handleClick(e) {
    e.preventDefault();
    document.querySelector('#cart-icon-bubble')?.click();
  }
}
if (!customElements.get('cart-drawer-opner')) {
  customElements.define('cart-drawer-opner', CartDrawerOpener);
}

function showCustomProductRecommendations(container,qty){
  if(window.innerWidth > 749) return;
  if(container.closest(".custom-product-recommendations")) return;
  if(!container.closest("#main-section-main-collection-product-grid")) return;

  if(qty > 0){
    var data_handle = container.closest(".new_product_card").getAttribute("data_handle");
    
    fetch(`/products/${data_handle}?view=custom-product-recommendations`)
    .then(res => res.text())
    .then(html => {
      var newDoc = new DOMParser().parseFromString(html, 'text/html'),
          mainContent = newDoc.querySelector('.custom-product-recommendations').outerHTML,
          currentCard = container.closest(".new_product_card"),
          allCards = [...document.querySelectorAll("#product-grid .new_product_card")],
          currentIndex = allCards.indexOf(currentCard);

      if(document.querySelector("#product-grid .custom-product-recommendations")){
        document.querySelector("#product-grid .custom-product-recommendations").remove();
      }

      if ((currentIndex + 1) % 2 === 0) {
        currentCard.insertAdjacentHTML("afterend", mainContent);
      } else {
        if (allCards[currentIndex + 1]) {
          allCards[currentIndex + 1].insertAdjacentHTML("afterend", mainContent);
        } else {
          currentCard.insertAdjacentHTML("afterend", mainContent);
        }
      }
      
      sectionJavascriptRun();
    })
    .catch(err => console.error('Fetch error:', err));
  }
}

function cartItemSetLocalStorage(cart) {
  if (!cart || !Array.isArray(cart.items)) {
    getCart();
    return;
  }

  const items = cart.items.map(item => ({
    id: item.id,
    quantity: item.quantity
  }));

  localStorage.setItem('cartItemLocalStorage', JSON.stringify(items));
  cardSyncQtyFromCart();

  if (window.initLazyImages) {
    window.initLazyImages();
  }

  sectionJavascriptRun();
}

function cardSyncQtyFromCart(){
  document.querySelectorAll('custom-qty-atc').forEach(el => {
    el.syncQtyFromCart();
  });
}

function setCartRelatedContent(){
  fetch(window.Shopify.routes.root + '?sections=mini-cart-popup,cart-icon-bubble')
    .then(res => res.json())
    .then(data => {
      
      if (data['mini-cart-popup']) {
        var mcpHTML = data['mini-cart-popup'],
            mcpDOC = new DOMParser().parseFromString(mcpHTML, 'text/html')
            mcpNewContent = mcpDOC.querySelector('#mini-cart-popup .js_content'),
            mcpCurrentContent = document.querySelector('#mini-cart-popup .js_content');

        if (mcpNewContent && mcpCurrentContent) {
          mcpCurrentContent.innerHTML = mcpNewContent.innerHTML;
        }
      }
      
      if (data['cart-icon-bubble']) {
        var cibHTML = data['cart-icon-bubble'],
            cibDOC = new DOMParser().parseFromString(cibHTML, 'text/html'),
            cibNewContent = cibDOC.querySelector('#shopify-section-cart-icon-bubble'),
            cibCurrentContent = document.querySelector('#cart-icon-bubble');
            
        if (cibNewContent && cibCurrentContent) {
          cibCurrentContent.innerHTML = cibNewContent.innerHTML;
        }
      }
    })
    .catch(err => console.error("mini-cart-popup error || cart-icon-bubble error:", err));
}

function updateCartDrawer(){
  fetch(window.Shopify.routes.root + '?sections=cart-drawer')
  .then(res => res.json())
  .then(data => {    
    if (data['cart-drawer']) {
      var cdHTML = data['cart-drawer'],
      cdDOC = new DOMParser().parseFromString(cdHTML, 'text/html'),
      cdNewContent = cdDOC.querySelector('#shopify-section-cart-drawer #CartDrawer'),
      cdCurrentContent = document.querySelector('#CartDrawer'),
      cart_item_count = parseInt(cdDOC.querySelector('#shopify-section-cart-drawer cart-drawer.drawer').getAttribute('cart_item_count'));
      
      if (cdNewContent && cdCurrentContent) {
        cdCurrentContent.innerHTML = cdNewContent.innerHTML;
      }
      if(cart_item_count > 0){
        document.querySelector('cart-drawer.drawer').classList.remove('is-empty');
      }else{
        document.querySelector('cart-drawer.drawer').classList.add('is-empty');
      }
      cartDrawer_ItemHeight();

      document.querySelector('cart-drawer')?.querySelector('#CartDrawer-Overlay')?.addEventListener('click', () => {
        document.querySelector('cart-drawer').close();
      });
    }
  })
  .catch(err => console.error("cart update error:", err));
}

function cartDrawer_ItemHeight(){
  document.querySelectorAll('cart-drawer .single_cart_item').forEach(function(singleElement){
    singleElement.style.setProperty('--item-height', singleElement.clientHeight + 'px');
  });  
  inside_cart_drawer_slider();
  new_product_add();
}

subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
  cartItemSetLocalStorage(event.cartData);
  cartDrawer_ItemHeight();
});

function cartUpdateSelectorElement(){
  fetch(window.Shopify.routes.root + '?sections=cart-drawer')
  .then(res => res.json())
  .then(data => {    
    if (data['cart-drawer']) {
      var cdHTML = data['cart-drawer'],
      cdDOC = new DOMParser().parseFromString(cdHTML, 'text/html'),
      cdNewContent = cdDOC.querySelector('#shopify-section-cart-drawer #CartDrawer'),
      cdCurrentContent = document.querySelector('#CartDrawer'),
      newHeaderUpdate = cdDOC.querySelector('#shopify-section-cart-drawer #CartDrawer .js_drawer_header_update'),
      headerUpdate = document.querySelector('#CartDrawer .js_drawer_header_update'),
      newFormUpdate = cdDOC.querySelector('#shopify-section-cart-drawer #CartDrawer .js_drawer_form_update'),
      formUpdate = document.querySelector('#CartDrawer .js_drawer_form_update'),
      newFreeProduct = cdDOC.querySelector('#shopify-section-cart-drawer #CartDrawer .js_free_product'),
      freeProduct = document.querySelector('#CartDrawer .js_free_product'),
      newFreeProductSuccess = cdDOC.querySelector('#shopify-section-cart-drawer #CartDrawer .js_free_product_success'),
      freeProductSuccess = document.querySelector('#CartDrawer .js_free_product_success'),
      newFooterUpdate = cdDOC.querySelector('#shopify-section-cart-drawer #CartDrawer .js_drawer_footer_update'),
      footerUpdate = document.querySelector('#CartDrawer .js_drawer_footer_update'),
      cart_item_count = parseInt(cdDOC.querySelector('#shopify-section-cart-drawer cart-drawer.drawer').getAttribute('cart_item_count'));
      
      if (newHeaderUpdate && headerUpdate) {
        headerUpdate.innerHTML = newHeaderUpdate.innerHTML;
      }
      if (newFormUpdate && formUpdate) {
        formUpdate.innerHTML = newFormUpdate.innerHTML;
      }
      if (newFreeProduct && freeProduct) {
        freeProduct.outerHTML = newFreeProduct.outerHTML;
      }
      if (newFreeProductSuccess && freeProductSuccess) {
        freeProductSuccess.outerHTML = newFreeProductSuccess.outerHTML;
      }
      if (newFooterUpdate && footerUpdate) {
        footerUpdate.innerHTML = newFooterUpdate.innerHTML;
      }
      if(cart_item_count > 0){
        document.querySelector('cart-drawer.drawer').classList.remove('is-empty');
      }else{
        if (cdNewContent && cdCurrentContent) {
          cdCurrentContent.innerHTML = cdNewContent.innerHTML;
        }
        document.querySelector('cart-drawer.drawer').classList.add('is-empty');
        setCartRelatedContent();
      }
      
      cartDrawer_ItemHeight();
      
      document.querySelector('cart-drawer')?.querySelector('#CartDrawer-Overlay')?.addEventListener('click', () => {
        document.querySelector('cart-drawer').close();
      });
    }
  })
  .catch(err => console.error("cart update error:", err));
}

function addRemoveUpdateSelector(id,qty){
  let updates = {
    [id]: qty
  };

  fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: {
        'Content-Type': 'application/json'
    },
    body: JSON.stringify({ updates })
  })
  .then(response => {
    return response.json();
  })
  .then(cart => {
    cartItemSetLocalStorage(cart);
    cartUpdateSelectorElement();
    document.body.classList.remove('stopCustomQtyATCWorking');
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}

function addRemoveUpdate(id,qty){
    let updates = {
        [id]: qty
    };

    fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ updates })
    })
    .then(response => {
      return response.json();
    })
    .then(cart => {
        cartItemSetLocalStorage(cart);
        setCartRelatedContent();
        document.body.classList.remove('stopCustomQtyATCWorking');
    })
    .catch((error) => {
        console.error('Error:', error);
    });
}

class CustomProductCard extends HTMLElement {
  constructor() {
    super();
    this.init = this.init.bind(this);
  }

  connectedCallback() {
    this.init();

    this.sectionLoadHandler = this.init.bind(this);
    this.sectionSelectHandler = this.init.bind(this);

    document.addEventListener("shopify:section:load", this.sectionLoadHandler);
    document.addEventListener("shopify:section:select", this.sectionSelectHandler);
  }

  disconnectedCallback() {
    document.removeEventListener("shopify:section:load", this.sectionLoadHandler);
    document.removeEventListener("shopify:section:select", this.sectionSelectHandler);
  }

  init() {
    var container = this,
        fetchUrl = container.getAttribute("data_handle"),
        productLimit = parseInt(container.getAttribute("data_product_limit")) || 8,
        skip = parseInt(container.getAttribute("data_skip")) || 0;

    if (!fetchUrl) return;

    fetch(fetchUrl)
    .then(res => res.text())
    .then(html => {
      var newDoc = new DOMParser().parseFromString(html, "text/html"),
          products = newDoc.querySelectorAll(".new_product_card"),
          newHtml = "";

      products.forEach((item, index) => {
        if (index >= skip && index < (skip + productLimit)){
          newHtml += item.outerHTML;
        }
      });

      if(container.closest(".section_content").querySelector(".swiper_last_arrow_slide")){
        newHtml += container.closest(".section_content").querySelector(".swiper_last_arrow_slide").innerHTML;
        container.closest(".section_content").querySelector(".swiper_last_arrow_slide").remove();
      }

      container.innerHTML = newHtml;
      if (window.initLazyImages) {
        window.initLazyImages();
      }
      
      sectionJavascriptRun();
    })
    .catch(err => console.error("Fetch error:", err));
  }
}

if (!customElements.get("custom-product-card")) {
  customElements.define("custom-product-card", CustomProductCard);
}

class CustomRecentlyViewedProductCard extends HTMLElement {
  constructor() {
    super();
    this.init = this.init.bind(this);
    this.isLoaded = false;
  }

  connectedCallback() {
    this.init();

    this.sectionLoadHandler = this.init.bind(this);
    this.sectionSelectHandler = this.init.bind(this);

    document.addEventListener("shopify:section:load", this.sectionLoadHandler);
    document.addEventListener("shopify:section:select", this.sectionSelectHandler);
  }

  disconnectedCallback() {
    document.removeEventListener("shopify:section:load", this.sectionLoadHandler);
    document.removeEventListener("shopify:section:select", this.sectionSelectHandler);
  }

  init() {
    if (this.isLoaded) return;
    var container = this,
        productLimit = parseInt(container.getAttribute("data_product_limit")) || 8,
        handles = JSON.parse(localStorage.getItem('RecentlyViewedProductHandleList')) || [];

    if(handles.length){
      // handles = handles.slice(0, productLimit);
      handles = [...new Set(handles)].slice(0, productLimit);
      this.renderProducts(handles);
    }else{
      if(container.closest('.recently_viewed_product_grid')){
        container.closest('.recently_viewed_product_grid').classList.add('hidden');
      }
    }    
  }

  async renderProducts(handles) {
    var html = "";
    this.isLoaded = true;

    const sleep = ms => new Promise(r => setTimeout(r, ms));
    for (const handle of handles) {
      try {
        await sleep(150);
        var res = await fetch(`/products/${handle}?view=single-product-card-slide`);
        if (!res.ok) continue;
        var text = await res.text(),
            doc = new DOMParser().parseFromString(text, "text/html"),
            productCard = doc.querySelector(".new_product_card");

        if (productCard) {
          html += productCard.outerHTML;
        }
      } catch (err) {
        console.error("Fetch error:", err);
      }
    }

    this.innerHTML = html;

    if (window.initLazyImages) {
      window.initLazyImages();
    }

    if (typeof sectionJavascriptRun === "function") {
      sectionJavascriptRun(); 
    }
  }
}

if (!customElements.get("custom-recently-viewed-product-card")) {
  customElements.define("custom-recently-viewed-product-card", CustomRecentlyViewedProductCard);
}

class CustomProductRecommendations extends HTMLElement {
  constructor() {
    super();
    this.init = this.init.bind(this);
    this.isLoaded = false;
  }

  connectedCallback() {
    this.init();

    this.sectionLoadHandler = this.init.bind(this);
    this.sectionSelectHandler = this.init.bind(this);

    document.addEventListener("shopify:section:load", this.sectionLoadHandler);
    document.addEventListener("shopify:section:select", this.sectionSelectHandler);
  }

  disconnectedCallback() {
    document.removeEventListener("shopify:section:load", this.sectionLoadHandler);
    document.removeEventListener("shopify:section:select", this.sectionSelectHandler);
  }

  async init() {
    if (this.isLoaded) return;
    var container = this,
        productLimit = parseInt(container.getAttribute("data_product_limit")) || 8,
        productId = container.getAttribute("data_product_id"),
        html = "";

    if (!productId) return;

    try {
      var res = await fetch(`/recommendations/products.json?product_id=${productId}&limit=${productLimit}`),
          data = await res.json();

      if (!data.products || !data.products.length) {
        container.innerHTML = "";
        container.closest(".single_tab_content")?.classList.add("hidden");
        return;
      }

      for (const product of data.products) {
        try {
          var cardRes = await fetch(`/products/${product.handle}?view=single-product-card-slide`);
          if (!cardRes.ok) continue;
          var text = await cardRes.text(),
              doc = new DOMParser().parseFromString(text, "text/html"),
              card = doc.querySelector(".new_product_card");

          if (card) {
            html += card.outerHTML;
          }
        } catch (err) {
          console.error("Card fetch error:", err);
        }
      }

      container.innerHTML = html;

      if (window.initLazyImages) {
        window.initLazyImages();
      }

      if (typeof sectionJavascriptRun === "function") {
        sectionJavascriptRun(); 
      }

    } catch (err) {
      console.error("Recommendations error:", err);
    }
  }
}

if (!customElements.get("custom-product-recommendations")) {
  customElements.define("custom-product-recommendations", CustomProductRecommendations);
}

function RecentlyViewedProductHandleList(handle) {
  if(handle){
    var handle_list = JSON.parse(localStorage.getItem('RecentlyViewedProductHandleList')) || [];
    handle_list = handle_list.filter((h) => h !== handle);
    handle_list.unshift(handle);    
    if (handle_list.length > 20) {
      handle_list = handle_list.slice(0, 20);
    }    
    localStorage.setItem('RecentlyViewedProductHandleList', JSON.stringify(handle_list));
  }
}

document.querySelectorAll('.fetch_get[data_fetch_url]').forEach(function(fetchGet){
  fetchGet.addEventListener("click",function(e){
    e.preventDefault();
    if(fetchGet.classList.contains("active")){
      return;
    }

    var fetch_url = fetchGet.getAttribute("data_fetch_url");

    fetchGet.closest(".shopify-section").querySelectorAll(".fetch_get[data_fetch_url]").forEach(function(inner_fetchGet){
      inner_fetchGet.classList.remove("active");
    });

    fetchGet.classList.add("active");
    
    fetch(fetch_url)
    .then(res => res.text())
    .then(html => {
      window.history.pushState({}, '', fetch_url);
      var newDoc = new DOMParser().parseFromString(html, 'text/html'),
          mainContent = newDoc.querySelector('main#MainContent').innerHTML;

      window.scrollTo({ top: 0, behavior: "smooth" });
      document.querySelector("main#MainContent").innerHTML = mainContent;

      if (window.initLazyImages) {
        window.initLazyImages();
      }
      
      if (typeof sectionJavascriptRun === "function") {
        sectionJavascriptRun(); 
      }
    })
    .catch(err => console.error('Fetch error:', err));
  });
});

function getCart() {
  fetch('/cart.js')
  .then(res => res.json())
  .then(cart => {
    cartItemSetLocalStorage(cart);
    setCartRelatedContent();
  })
  .catch(err => console.error('Error:', err));
}

getCart();

function inside_cart_drawer_slider() {
  document.querySelectorAll('.cart_extra_products.swiper:not(.swiper-initialized)').forEach(function (this_elem) {
      new Swiper(this_elem, {
          slidesPerView: "auto",
          spaceBetween: 12,
          freeMode: true,
          autoHeight: true,
          loop: false
      });
  });
}

function blockCartUI() {
  document.querySelector('#main-cart-items')?.classList.add('pointer-events-none');
  document.querySelector('cart-drawer')?.classList.add('pointer-events-none');
}

function unblockCartUI() {
  document.querySelector('#main-cart-items')?.classList.remove('pointer-events-none');
  document.querySelector('cart-drawer')?.classList.remove('pointer-events-none');
}

function new_product_add(){
  document.querySelectorAll(".single_product_inner .add_item_JS").forEach(function(atcItem){
    if (atcItem.dataset.atcBound === "true") return;
    atcItem.dataset.atcBound = "true"; 
    
    atcItem.addEventListener("click",function(){
      
      var isCartDrawer = atcItem.closest('cart-drawer'),
          isCartPage = document.querySelector('cart-items');

      blockCartUI();

      var currantClick = atcItem.closest(".cart_free_product");

      if(currantClick){
        currantClick.classList.add("hidden");
        atcItem.closest('.cart_data_main_JS').querySelector('.cart_free_product.success_main').classList.remove("hidden");
      }

      atcItem.closest(".single_product_inner").classList.add("hidden");
      var variantId = parseInt(atcItem.getAttribute("itemID")),
          quantity = parseInt(atcItem.getAttribute("itemQTY")),
          formData = {
            items: [{ id: variantId, quantity: quantity }]
          };

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      })
      .then(res => res.json())
      .then((response) => {
        if (isCartDrawer) {
          updateCartDrawer();
        } else if (isCartPage) {
          console.log("cart-page");
        }

        if(currantClick){          
          document.querySelectorAll('.cart_free_product.success_main').forEach(function(single_free_pro_block){
            single_free_pro_block.classList.remove("hidden");
          });
          setTimeout(() => {
            document.querySelectorAll('.cart_free_product.success_main').forEach(function(single_free_pro_block){
              single_free_pro_block.classList.add("hidden");
            });
          }, 2500);
        }
        
        unblockCartUI();
      })
      .catch(err => console.error(err));
    });
  });
}

function loadmoreinfinity() {
  var isLoading = false,
      infinity_scroll = document.querySelector(".infinity_scroll"),
      infinity_scroll_spinner = document.querySelector(".infinity_scroll_spinner");

  if (!infinity_scroll) return;

  window.addEventListener('scroll', function() {
    if (isLoading) return;

    var currentPage = parseInt(infinity_scroll.getAttribute("data-current-page")),
        totalPage = parseInt(infinity_scroll.getAttribute("data-total-page")),
        dataUrl = infinity_scroll.getAttribute("data-next-url");

    if (!dataUrl || currentPage >= totalPage) {
      return; 
    }
    
    var elementTop = infinity_scroll.getBoundingClientRect().top,
        triggerRange = window.innerHeight * 2;

    if (elementTop <= triggerRange) {
      
      isLoading = true;

      if (infinity_scroll_spinner) {
        infinity_scroll_spinner.classList.remove('hidden');
      }

      fetch(dataUrl)
        .then((response) => {
          if (!response.ok) throw new Error("Network response was not ok");
          return response.text();
        })
        .then((html) => {
          var parser = new DOMParser(),
              doc = parser.parseFromString(html, "text/html"),
              productGrid = doc.querySelector("#product-grid");

          if (productGrid) {
            var newhtml = productGrid.innerHTML;
            document.querySelector("#product-grid").insertAdjacentHTML("beforeend", newhtml);
          }

          var nextScrollEl = doc.querySelector('.infinity_scroll');
          if (nextScrollEl) {
            var newCurrentPage = parseInt(nextScrollEl.getAttribute("data-current-page")),
                newTotalPage = parseInt(nextScrollEl.getAttribute("data-total-page")),
                newDataUrl = nextScrollEl.getAttribute("data-next-url");

            infinity_scroll.setAttribute("data-current-page", newCurrentPage);
            infinity_scroll.setAttribute("data-total-page", newTotalPage);
            infinity_scroll.setAttribute("data-next-url", newDataUrl);

            if (window.initLazyImages) {
              window.initLazyImages();
            }

            if (newCurrentPage < newTotalPage) {
              isLoading = false; 
            }
          }
        })
        .catch((error) => {
          console.error("Error loading more products via scroll:", error);
          isLoading = false;
        })
        .finally(() => {
          if (infinity_scroll_spinner) {
            infinity_scroll_spinner.classList.add('hidden');
          }
        });
    }
  });
}

loadmoreinfinity();

subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
  var variant = event.data.variant;
  if (window.initLazyImages) {
    window.initLazyImages();
  }

  stickyAtcUpdate(event,variant);
});

function stickyAtcUpdate(event,variant){
  var elementSelector = document.querySelector(`#shopify-section-${event.data.sectionId}`);
  
  if(elementSelector){
    var FinalElementSelector = event.data.thisData.closest(".mainContent").querySelector(`#shopify-section-sticky-atc`);
    if(FinalElementSelector){
      fetch(window.location.pathname + '?variant=' + variant.id + '&section_id=sticky-atc')
      .then(r => r.text())
      .then(htmlResponse => {
        var newDoc = new DOMParser().parseFromString(htmlResponse, 'text/html'),
            mainSectionData = newDoc.querySelector('#shopify-section-sticky-atc');
        FinalElementSelector.innerHTML = mainSectionData.innerHTML;
      });   
    }
  }
}

function triggerATC(element){
  var finalElement = element.closest(".mainContent").querySelector("product-info product-form form button");
  if(finalElement){
    finalElement.click();
  }
}

function collectionNavigationHeightSetAttr(){
  if(document.querySelector('.collection_navigation')){
    var elementHeight = document.querySelector('.collection_navigation').getBoundingClientRect().height;
    document.querySelector(':root').style.setProperty('--collection-navigation-height', elementHeight+'px');
  }else{
    document.querySelector(':root').style.setProperty('--collection-navigation-height', '0px');
  }
  document.documentElement.style.setProperty('--header-height', `${document.querySelector('.section-header').offsetHeight}px`);
}

collectionNavigationHeightSetAttr();

function collectionNavigationSlider(){

    document.querySelectorAll('.collection_navigation .cn_l2_inner.swiper:not(.swiper-initialized)').forEach(function (this_elem){
      var activeSlide = this_elem.querySelector('.swiper-slide.active'),
          activeIndex = activeSlide ? [...activeSlide.parentElement.children].indexOf(activeSlide) : 0;

      const sectionSwiperSlider = new Swiper(this_elem, {
        slidesPerView: "auto",
        spaceBetween: 6,
        centeredSlides: true, 
        centeredSlidesBounds: true,
        loop: false,
        freeMode: true,
        initialSlide: activeIndex
      });
      
      collectionNavigationHeightSetAttr();
    });

    document.querySelectorAll('.collection_navigation .cn_l3_inner.swiper:not(.swiper-initialized)').forEach(function (this_elem){
      var activeSlide = this_elem.querySelector('.swiper-slide.active'),
          activeIndex = activeSlide ? [...activeSlide.parentElement.children].indexOf(activeSlide) : 0;

      const sectionSwiperSlider = new Swiper(this_elem, {
        slidesPerView: "auto",
        spaceBetween: 4,
        loop: false,
        freeMode: true,
        initialSlide: activeIndex
      });
      
      collectionNavigationHeightSetAttr();
    });

    document.querySelectorAll('.collection_navigation .single_link').forEach(function (this_elem){
      this_elem.addEventListener('click',function(e){
        e.preventDefault();

        if(this_elem.classList.contains('has_submenu')){
          var datatarget = this_elem.getAttribute('datatarget');

          this_elem.closest('.collection_navigation_top').querySelectorAll('.single_link').forEach(function(single_elem){
            single_elem.classList.remove('active');
          });

          this_elem.closest('.collection_navigation').querySelectorAll('.collection_navigation_bottom .cn_l3_inner').forEach(function(single_elem){
            single_elem.classList.add('hidden');
          });
          
          this_elem.classList.add('active');
          this_elem.closest('.collection_navigation').querySelector(`.collection_navigation_bottom .cn_l3_inner[datatarget='${datatarget}']`).classList.remove('hidden');
          this_elem.closest('.collection_navigation').querySelector(`.collection_navigation_bottom .cn_l3_inner[datatarget='${datatarget}'] .all_parent`).click();
          
        }else{
          
          var datahref = this_elem.getAttribute('href'),
              datatarget = this_elem.getAttribute('datatarget');
              
          if(datahref == 'javascript:void(0)'){
            return;
          }
          
          if(this_elem.closest('.collection_navigation_top')){
            this_elem.closest('.collection_navigation_top').querySelectorAll('.single_link').forEach(function(single_elem){
              single_elem.classList.remove('active');
            });

            this_elem.closest('.collection_navigation').querySelectorAll('.collection_navigation_bottom .cn_l3_inner').forEach(function(single_elem){
              single_elem.classList.add('hidden');
            });
          }

          if(this_elem.closest('.collection_navigation_bottom')){            
            this_elem.closest('.collection_navigation_bottom').querySelectorAll('.single_link').forEach(function(single_elem){
              single_elem.classList.remove('active');
            });
          }

          this_elem.classList.add('active');
          collectionUpdate(datahref);
        }
        
        collectionNavigationHeightSetAttr();
      });
    });
}

collectionNavigationSlider();

function collectionNavigationDesktop(){
  document.querySelectorAll('.collection_navigation_desktop .single_link').forEach(function (this_elem){
    this_elem.addEventListener('click',function(e){
      e.preventDefault();

      var datahref = this_elem.getAttribute('href');
  
      this_elem.closest('.collection_navigation_desktop').querySelectorAll('.single_link').forEach(function(single_elem){
        single_elem.classList.remove('active');
      });
      
      this_elem.classList.add('active');
      collectionUpdate(datahref);
    });
  });
}

collectionNavigationDesktop();

function collectionNavigationMobile(){
  document.querySelectorAll('.collection_navigation_mobile .single_link').forEach(function (this_elem){
    this_elem.addEventListener('click',function(e){
      e.preventDefault();

      var datahref = this_elem.getAttribute('href');
  
      this_elem.closest('.collection_navigation_mobile').querySelectorAll('.single_link').forEach(function(single_elem){
        single_elem.classList.remove('active');
      });
      
      this_elem.classList.add('active');
      
      if(this_elem.closest('.shopify-section').querySelector(`.collection_navigation .single_link[href='${datahref}']`)){
        this_elem.closest('.shopify-section').querySelector(`.collection_navigation .single_link[href='${datahref}']`).click();
      }else{
        collectionUpdate(datahref);
      }

    });
  });
}

collectionNavigationMobile();

function collectionUpdate(fetch_url){
  var newFetch_url = `${fetch_url}?section_id=main-collection-product-grid`;
  fetch(newFetch_url)
    .then(res => res.text())
    .then(html => {
      window.history.pushState({}, '', fetch_url);

      var newDoc = new DOMParser().parseFromString(html, 'text/html'),
          mainSectionData = newDoc.querySelector('#main-section-main-collection-product-grid').outerHTML,
          collection_breadcrumb_with_title = newDoc.querySelector('.collection_breadcrumb_with_title').outerHTML,
          tab_control = newDoc.querySelector('.tab_control').outerHTML,
          data_title = newDoc.querySelector('.main_collection').getAttribute('data_title'),
          tabStatus = false,
          drawerStatus = false,
          data_tab;

      if(document.querySelector('.collection_navigation_desktop[open]')){
        tabStatus = true;
      }

      if(document.querySelector('menu-drawer > .mobile_main_filter_control > details[open]') && document.querySelector('.collection_navigation_mobile[open]') && document.querySelector('.tab_control .single_tab.active')){
        drawerStatus = true;
        data_tab = document.querySelector('.tab_control .single_tab.active').getAttribute('data_tab');
      }

      document.querySelector("#main-section-main-collection-product-grid").outerHTML = mainSectionData;
      document.querySelector(".collection_breadcrumb_with_title").outerHTML = collection_breadcrumb_with_title;
      
      if(tabStatus && document.querySelector('.collection_navigation_desktop')){
        document.querySelector('.collection_navigation_desktop').setAttribute('open', true);
        collectionNavigationDesktop();
      }

      if(drawerStatus && document.querySelector('menu-drawer > .mobile_main_filter_control > details') && document.querySelector('.collection_navigation_mobile')){
        document.querySelector('menu-drawer > .mobile_main_filter_control > details').classList.add('menu-opening');
        document.querySelector('menu-drawer > .mobile_main_filter_control > details').setAttribute('open', true);
        document.querySelector('.collection_navigation_mobile').setAttribute('open', true);
        
        if(document.querySelector(`.tab_control .single_tab[data_tab="${data_tab}"]`)){
          document.querySelector(`.tab_control .single_tab[data_tab="${data_tab}"]`).click();
        }
      }
      
      collectionNavigationMobile();

      window.scrollTo({ top: 0, behavior: "smooth" });

      if (window.initLazyImages) {
        window.initLazyImages();
      }

      loadmoreinfinity();
      sortByCollection();

      document.title = data_title;
      if(document.querySelector('header.header .collection_title_js')){
        document.querySelector('header.header .collection_title_js').innerHTML = data_title;
      }
    })
    .catch(err => console.error('Fetch error:', err));
}

function sortByCollection(){
  if(document.querySelector(".custom_sort_wrapper")){
    document.querySelectorAll(".custom_sort_wrapper .selected_sort_text_wrapper").forEach(function(dropdown_open){
      dropdown_open.addEventListener("click",function(e){
        e.stopPropagation();
        dropdown_open.closest(".custom_sort_wrapper").classList.toggle("active");
      });
    });

    document.querySelectorAll(".custom_sort_wrapper .custom_sort_option").forEach(function(dropdown_option){
      dropdown_option.addEventListener("click",function(){        
        dropdown_option.closest(".custom_sort_wrapper").classList.remove("active");
      });
    });

    document.addEventListener("click", function(e) {
      document.querySelectorAll(".custom_sort_wrapper.active").forEach(function(wrapper) {
        if (!wrapper.contains(e.target)) {
          wrapper.classList.remove("active");
        }
      });
    });
  }
}

sortByCollection();

document.addEventListener("click", async function(e) {
  var clickTarget = e.target;
  if(clickTarget.classList.contains("media_popup")){
    var clickParent = clickTarget.closest("media-gallery"),
        media_id = parseInt(clickTarget.closest(".product__media-item").getAttribute("media_id")),
        targetIndex = 0;
        
    if(clickParent){
        if(clickParent.querySelector(".product_media_popup_data_JS")){
          var mediaPopupHTML = clickParent.querySelector(".product_media_popup_data_JS").innerHTML,
              popupHTML = `
                <div class="popup_main hidden product_media_popup">
                  <div class="popup">
                    ${closePopupHtml}
                    <div class="popup_data popup_data_JS">${mediaPopupHTML}</div>
                  </div>
                </div>
              `;

            document.body.insertAdjacentHTML("beforeend", popupHTML);

            if(document.querySelector('.product_media_popup .thum_media_modal.swiper') && document.querySelector('.product_media_popup .main_media_modal.swiper')){
              const mediaThumbSwiper = new Swiper(document.querySelector('.product_media_popup .thum_media_modal.swiper'), {
                direction: 'vertical',
                spaceBetween: 0,
                freeMode: true,
                watchSlidesProgress: true,
                watchOverflow: true,
                breakpoints: {
                  0: {
                    direction: 'horizontal',  
                    slidesPerView: 5,    
                    spaceBetween: 4,     
                  },
                  989: {
                    direction: 'vertical',    
                    slidesPerView: 7,         
                    spaceBetween: 0,
                  }
                }
              });
              
              document.querySelectorAll('.product_media_popup .main_media_modal .swiper-slide').forEach((slide, index) => {
                if(parseInt(slide.getAttribute("media_id")) === media_id){
                  targetIndex = index;
                }
              });

              const mediaMainSwiper = new Swiper(document.querySelector('.product_media_popup .main_media_modal.swiper'), {
                initialSlide: targetIndex,
                spaceBetween: 10,
                zoom: true,
                autoHeight: true,
                navigation: {
                  nextEl: '.main_media_modal_next',
                  prevEl: '.main_media_modal_prev'
                },
                thumbs: {
                  swiper: mediaThumbSwiper
                },
                on: {
                  slideChange: function () {
                    handleSlideMediaVideoPlay(this);
                  }
                }
            });

            if(document.querySelector('.product_media_popup')){
              var slideCount = document.querySelectorAll('.product_media_popup .thum_media_modal.swiper .swiper-slide').length;
              document.querySelector('.product_media_popup').setAttribute("slideCount",`${slideCount}`);
              document.querySelector('.product_media_popup').classList.remove('hidden')
            }
          }
        }
    }
  }

  if(clickTarget.closest('.close_popup_JS') && clickTarget.closest('.product_media_popup')){
    clickTarget.closest('.product_media_popup').remove();
  }

  // How to use Popup
  if(clickTarget.classList.contains("popup_opner_js")){
    var clickParent = clickTarget.closest(".view_more_data");
        
    if(clickParent){
      if(clickParent.querySelector(".popup_data_js")){
        var howToUsePopupHTML = clickParent.querySelector(".popup_data_js").innerHTML,
          popupHTML = `
            <div class="popup_main hidden howtouse_popup">
              <div class="popup">
                <span class="close close_popup_JS">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M9.56994 18.8201C9.37994 18.8201 9.18994 18.7501 9.03994 18.6001L2.96994 12.5301C2.67994 12.2401 2.67994 11.7601 2.96994 11.4701L9.03994 5.40012C9.32994 5.11012 9.80994 5.11012 10.0999 5.40012C10.3899 5.69012 10.3899 6.17012 10.0999 6.46012L4.55994 12.0001L10.0999 17.5401C10.3899 17.8301 10.3899 18.3101 10.0999 18.6001C9.95994 18.7501 9.75994 18.8201 9.56994 18.8201Z" fill="#0D0D0D"/>
                    <path d="M20.5 12.75H3.67004C3.26004 12.75 2.92004 12.41 2.92004 12C2.92004 11.59 3.26004 11.25 3.67004 11.25H20.5C20.91 11.25 21.25 11.59 21.25 12C21.25 12.41 20.91 12.75 20.5 12.75Z" fill="#0D0D0D"/>
                  </svg>
                </span>
                <div class="popup_data popup_data_JS">${howToUsePopupHTML}</div>
              </div>
            </div>
          `;

        document.body.insertAdjacentHTML("beforeend", popupHTML);

        if (window.initLazyImages) {
          window.initLazyImages();
        }

        if(document.querySelector('.howtouse_popup')){
          document.querySelector('.howtouse_popup').classList.remove('hidden')
        }
      }
    }
  }
  
  if(clickTarget.closest('.close_popup_JS') && clickTarget.closest('.howtouse_popup')){
    clickTarget.closest('.howtouse_popup').remove();
  }

});

function handleSlideMediaVideoPlay(swiper){

  if(!swiper || !swiper.slides || swiper.activeIndex === undefined){
    return;
  }

  var currentSlide = swiper.slides[swiper.activeIndex];

  if(!currentSlide){
    return;
  }
  
  var vimeoFrame = currentSlide.querySelector("iframe[src*='vimeo.com']"),
      play_button = currentSlide.querySelector("deferred-media .deferred-media__poster-button");

  if(play_button){
    play_button.click();
  }
  
  if (vimeoFrame) {
    var src = vimeoFrame.src;

    src = src.replace(/autoplay=\d/, "").replace(/loop=\d/, "").replace(/muted=\d/, "").replace(/controls=\d/, "").replace(/playsinline=\d/, "");

    var params = [
      "autoplay=1",
      "loop=1",
      "muted=1",
      "controls=1",
      "playsinline=1",
      "byline=0",
      "title=0"
    ];

    if (src.includes("?")) {
      src = src.split("?")[0] + "?" + params.join("&");
    } else {
      src = src + "?" + params.join("&");
    }

    vimeoFrame.src = src;
  }
}

// Search Code Start
function KeyboardRemove(){ 
  document.querySelectorAll("header .custom_search_extra").forEach(function(single_elem){
    var searchInput = single_elem.closest("form").querySelector(`input[type="search"]`);
    if(searchInput){
      single_elem.addEventListener('scroll', function() {
        if (document.activeElement === searchInput && single_elem.scrollTop > 5) {
          searchInput.blur();
        }
      },{passive: true});
    }
  });
}

KeyboardRemove();

document.addEventListener('mouseup', function (e) {
  var containers = document.querySelectorAll('header.header predictive-search, header.header .custom_search_extra, header.header .header_search__input'),
      clickedInside = false;

  containers.forEach(function(container) {
    if (container.contains(e.target)) {
      clickedInside = true;
    }
  });

  if(document.body.classList.contains('stopCustomQtyATCWorking')){
    clickedInside = true;
  }
  
  if(document.body.classList.contains('stopSearchCloseJS')){
    clickedInside = true;
  }

  if (!clickedInside) {
    document.querySelector("header.header").classList.remove("search_active");
  }
});

document.querySelectorAll("header.header .search-modal__form .header_search__input").forEach(function(single_search){
  single_search.addEventListener("click", function(e){
    e.stopPropagation();
    this.closest("header.header").classList.add("search_active");
    header_height();

    const searchExtra = this.closest("form").querySelector(".custom_search_extra");
    if(searchExtra){
      if(searchExtra.scrollTop !== 0) {
        searchExtra.scrollTop = 0;
      }
    }
    this.focus();
  });
});

document.addEventListener("click", function (e) {
  if (e.target.closest(".mobile_arrow")) {
    document.querySelector("header.header")?.classList.remove("search_active");
  }
});

function header_height(){
  if(document.querySelector('header.header')){
    var main_header = document.querySelector('header.header'),
    header_height = main_header.offsetHeight,
    r = document.querySelector(':root');
    r.style.setProperty('--main-height', header_height+'px')
  }
}
header_height();

window.addEventListener("load", function () {
  header_height();
});
// Search Code End

// Back button for mobile Start
document.addEventListener("click", function(e) {
  const clickTarget = e.target.closest(".back_JS");

  if (clickTarget && window.innerWidth < 750) {
    e.preventDefault();

    const currentPath = window.location.pathname;
    const isFromOurSite = document.referrer && document.referrer.includes(window.location.hostname);

    if (currentPath.includes('/products/') || currentPath.includes('/collections/')) {
      if (window.history.length > 1 && isFromOurSite) {
        window.history.back();
      } else {
        window.location.href = '/';
      }
      return;
    }

    if (window.history.length > 1 && isFromOurSite) {
      window.history.back();
    } else {
      window.location.href = '/';
    }
  }
});

window.addEventListener('popstate', function(event) {
  window.location.reload();
});

// Back button for mobile End

// Event Fire Code Start
subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
  var variant = event.data.variant;
  
  const popupContainer = document.querySelector(".popup_main.main_product_card_popup .custom_slide.active_slide");
  if(popupContainer){
    fireMetaViewContentShopify(variant.id, popupContainer);
  }
});

function getShopifyProduct(productData) {
  const el = productData.querySelector("#shopify-product-json");
  if (!el) return null;
  return JSON.parse(el.textContent);
}

function getVariantById(variantId, productData) {
  const product = getShopifyProduct(productData);
  if (!product) return null;
  return product.variants.find(v => v.id == variantId);
}

function fireMetaViewContentShopify(variantId, productData) {
  if (typeof fbq !== "function") return;
  
  const product = getShopifyProduct(productData);
  const variant = getVariantById(variantId, productData);
  if (!product || !variant) return;
  const productURL = window.location.origin + '/products/' + product.handle + '?variant=' + variant.id;
  window.history.replaceState(null, null, productURL);

  const price = variant.price / 100;
  
  fbq("track", "ViewContent", {
    content_category: product.type, 
    content_ids: [product.id],
    content_name: product.title + " - " + variant.title,
    content_type: "product_group",
    contents: [{
      id: product.id,
      sku: variant.id,
      item_price: price,
      currency: Shopify.currency.active,
      quantity: 1
    }],
    currency: Shopify.currency.active,
    value: price
  });

  gtag("event", "view_item", {
    currency: Shopify.currency.active,
    value: price,
    items: [{
      item_id: variant.id.toString(),
      item_name: product.title + " - " + variant.title,
      item_brand: product.vendor || "",
      item_category: product.type || "",
      item_variant: variant.title,
      price: price,
      quantity: 1
    }]
  });
}
// Event Fire Code End